'use strict';

(function (angular) {
    angular.module('zp').service('GeolocationService', geolocationService);

    /** @ngInject */
    function geolocationService($geolocation, $rootScope) {

        var service = this;

        service.loadCurrentLocation = loadCurrentLocation;
        service.getGeoDistance = getDistanceFromLatLonInKm;

        var _fallbackLocation = { latitude: 44.802358, longitude: 20.466471 };

        //////////////////////////////////////////////////

        function loadCurrentLocation() {
            $rootScope.currentLocation = _fallbackLocation;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    $rootScope.currentLocation = position.coords;
                    console.log('Location found');
                    console.log(position);
                }, function (err) {
                    console.log('Location error');
                    console.log(err);
                }, {
                    enableHighAccuracy: false,
                    timeout: 60000,
                    maximumAge: 300000
                });
            }
        }

        function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            var R = 6371; // Radius of the earth in km
            var dLat = deg2rad(lat2 - lat1); // deg2rad below
            var dLon = deg2rad(lon2 - lon1);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c; // Distance in km
            return d;
        }

        function deg2rad(deg) {
            return deg * (Math.PI / 180);
        }
    }
})(window.angular);